export default __webpack_public_path__ + "static/media/BC_294_BC_R9491_tn.4f79fac7.jpg";